import React, { Component } from 'react';
import { Row, Col } from 'antd';
import { createMarkup, cleanString } from '../../util/renderHelper';

// SVGs
import { ReactComponent as IconChevronRight } from '../Sprites/icon-chevron-right.svg';

// Components
import ProviderTypeModal from '../ProviderTypeModal';

const CategoryPanelTagline = ({ tagline }) => (
  <p
    className="category-panel__tagline"
    dangerouslySetInnerHTML={createMarkup(cleanString(tagline))}
  />
);

const CategoryPanelButton = ({ text, clickAction }) => (
  <button
    className="category-panel__button"
    aria-label="Open Provider Type Modal"
    onClick={clickAction}
  >
    {text}
    <IconChevronRight className="category-panel__button-icon" />
  </button>
);

class ProviderCategoryPanel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false
    };
  }

  showModal = () => {
    document.getElementsByClassName('provider-type-toggle__button')[0].click();
  };

  render() {
    const { tagline, btnText } = this.props;

    return (
      <div className="category-panel">
        <span className="hidden">
          <ProviderTypeModal />
        </span>
      </div>
    );
  }
}

export default ProviderCategoryPanel;
